<template>
  <div class="content-box int-rank-box">
    <div class="content-box-title">
      <div style="display: flex;align-items: start;">
        <van-image
          :src="require('../../assets/img/title-icon.png')"
          width="18px"
          height="18px"
          class="icon"
        ></van-image>
        <span>学员学分排名</span>
      </div>
      <div class="total-rank" @click="goTotal">全部排名 ></div>
    </div>
    <div class="rank-list" style="background-color: #fff;">
      <div class="rank-list-item" v-for="(item, i) in userList" :key="i">
        <div class="rank-name">
          <div class="rank-icon">
            <span>{{ i + 1 }}</span>
          </div>
          <span class="user">{{ item.name }}</span>
          <van-image
            width="52"
            height="16"
            :src="require('../../assets/img/icon-' + item.passportName + '.png')"
          />
          <!-- <div class="rank-badge">
            <div v-for="(e, key) in item.userMapList" :key="key">
              <van-image :src="e.img" width="15" height="13" />
            </div>
          </div> -->
        </div>
        <div class="rank-post">{{ item.postNameView }}</div>
        <div class="rank-num">{{ item.integral.toLocaleString('en-US') }}</div>
        <div class="rank-btn" @click="goDetail(item.ppn)">详情<span> > </span></div>
      </div>
    </div>
  </div>
</template>

<script>
import { getXyIntegral } from '@/api/common/index.js'
export default {
  name: 'userRank',
  props: {
    dealerId: {
      type: String,
    },
  },
  data() {
    return {
      userList: [],
      userType: localStorage.getItem('userType'),
    }
  },
  watch: {
    dealerId() {
      this.getUserList()
    },
  },
  methods: {
    goDetail(id) {
      this.$router.push({
        path: '/userIndex',
        query: {
          id: id,
        },
      })
    },
    getUserList() {
      getXyIntegral(
        {
          companyId:
            this.userType == '0' ? JSON.parse(localStorage.getItem('user')).companyId : null,
          dealerId: this.userType == '1' || this.dealerId != null ? this.dealerId : null,
        },
        1,
        5
      ).then((res) => {
        this.userList = res.rows
      })
    },
    goTotal() {
      this.$router.push({
        path: '/totalRank',
        query: {
          id: this.dealerId,
          isDealer: 1,
        },
      })
    },
  },
  created() {},

  mounted() {
    console.log(this.dealerId)
    //this.getUserList()
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.int-rank-box {
  .content-box-title {
    justify-content: space-between;
    // margin-bottom: 10px;
    .total-rank {
      background-color: #f5f5f5;
      width: 80px;
      height: 20px;
      line-height: 20px;
      text-align: right;
      color: #403f45;
      font-size: 11px;
      font-style: normal;
      font-weight: 400;
    }
  }
}
</style>
